import axios from "axios";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Spinner from "../component/Spinner";
import { server2 } from "../constant/config";
import { useFetchData } from "../hooks/useFetchData";
import Layout from "../layout/Layout";
import { useAuthConfig } from "../hooks/useAuthConfig";

export const KunjiReleaseDates = () => {
  const [searchParams] = useSearchParams();
  const [localLoading, setLoading] = useState(false);
    const boardId = Number(searchParams.get("board"));
    const classId = Number(searchParams.get("class"));
  const subjectId = Number(searchParams.get("subject"));
  const config=useAuthConfig()
  const { data, loading, error } = useFetchData(`${server2}/v1/kunjireleasedates?board_id=${boardId}&class_id=${classId}&subject_id=${subjectId}`);
  const [toRender, setToRender] = useState([]);

  useEffect(() => {
    const fetchChapters = async () => {
      if (!data?.kunji_release) return;
      const releasesWithNames = await Promise.all(
        data.kunji_release.map(async ({ id, release_date, year, chapter_id }) => {
          try {
            setLoading(true);
            const res = await axios.get(`${server2}/v1/chapters/${chapter_id}`, config);
            setLoading(false);
            return { id, release_date, year, chapter_name: res.data.chapters.name };
          } catch {
            setLoading(false);
            return { id, release_date, year, chapter_name: "Unknown Chapter" };
          }
        })
      );
      setToRender(releasesWithNames);
    };
    fetchChapters();
  }, [data]);
    const handleEdit = (id) => () => { 
        window.open(`/addOrUpdateKunjiReleaseDate?id=${id}&board_id=${boardId}&class_id=${classId}&subject_id=${subjectId}&edit=true`, "_blank");
    }
    const handleAdd = () => { 
        window.open(`/addOrUpdateKunjiReleaseDate?board_id=${boardId}&class_id=${classId}&subject_id=${subjectId}&edit=false`, "_blank");
    }

  if (error)
    return (
      <Layout>
        <div className="text-red-500 text-center mt-4">{error}</div>
      </Layout>
    );

  if (loading || localLoading)
    return (
      <Layout  >
        <Spinner />
      </Layout>
    );

  return (
    <Layout>
      <div className="container mx-auto p-4">
              <div className="flex justify-between items-center mb-6">
                  <h1 className="text-2xl font-bold mb-4">Kunji Release Dates</h1>
                  <button className="bg-blue-600 text-white rounded-lg p-2 hover:bg-blue-700" onClick={handleAdd} >Add Release Date</button>
              </div>
              
        {toRender.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 divide-y divide-gray-200 shadow-md rounded-lg">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">No.</th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">Release Date</th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">Year</th>
                  <th className="px-4 py-2 text-left font-semibold text-gray-700">Chapter Name</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {toRender.map((item,index) => (
                  <tr key={item.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2">{index + 1}</td>
                    <td className="px-4 py-2">{new Date(item.release_date).toLocaleDateString()}</td>
                    <td className="px-4 py-2">{item.year}</td>
                    <td className="px-4 py-2 text-blue-600">{item.chapter_name}</td>
                    <td className="px-4 py-2">
                      <button className="bg-blue-600 text-white rounded-lg p-1 hover:bg-blue-700" onClick={handleEdit(item.id)} >Edit Detail</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center text-gray-500">No release dates available.</div>
        )}
      </div>
    </Layout>
  );
};
